/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Surface_Dock_CloseInputs */

const en_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Close ${i?.title}`)
};

const ar_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`إغلاق ${i?.title}`)
};

const bn_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} বন্ধ করুন`)
};

const de_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} schließen`)
};

const es_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cerrar ${i?.title}`)
};

const fr_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fermer ${i?.title}`)
};

const pt_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fechar ${i?.title}`)
};

const zh_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`关闭 ${i?.title}`)
};

const tr_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} penceresini kapat`)
};

const ru_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Закрыть ${i?.title}`)
};

const pl_surface_dock_close = /** @type {(inputs: Surface_Dock_CloseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zamknij ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Close {title}" |
*
* @param {Surface_Dock_CloseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const surface_dock_close = /** @type {((inputs: Surface_Dock_CloseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Surface_Dock_CloseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_surface_dock_close(inputs)
	if (locale === "bn") return bn_surface_dock_close(inputs)
	if (locale === "de") return de_surface_dock_close(inputs)
	if (locale === "es") return es_surface_dock_close(inputs)
	if (locale === "fr") return fr_surface_dock_close(inputs)
	if (locale === "pt") return pt_surface_dock_close(inputs)
	if (locale === "zh") return zh_surface_dock_close(inputs)
	if (locale === "tr") return tr_surface_dock_close(inputs)
	if (locale === "ru") return ru_surface_dock_close(inputs)
	if (locale === "pl") return pl_surface_dock_close(inputs)
	return en_surface_dock_close(inputs)
});